import React, { useState, useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { submitFeedback } from '../../utils/api';

const PriceFeedbackForm = ({ productId, productName }) => {
  const [comment, setComment] = useState('');
  const [status, setStatus] = useState(null);
  const [showForm, setShowForm] = useState(true);
  const { theme } = useTheme();

  // Add effect to handle auto-hiding success message after 5 seconds
  useEffect(() => {
    let timer;
    if (status && status.type === 'success') {
      // Optionally hide success message after 5 seconds
      timer = setTimeout(() => {
        setStatus(null);
        setShowForm(true); // Show the form again if needed
      }, 5000);
    }
    
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [status]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!comment.trim()) return;

    try {
      const sessionDetails = {
        productId,
        productName,
        page: 'price-comparison'
      };

      await submitFeedback(comment, sessionDetails);
      setStatus({
        type: 'success',
        message: 'Thanks! We appreciate your feedback — it helps us keep this tool accurate and awesome.'
      });
      setComment('');
      setShowForm(false); // Hide the form on successful submission
    } catch (error) {
      console.error('Feedback submission error:', error);
      setStatus({
        type: 'error',
        message: 'Failed to submit feedback. Please try again.'
      });
    }
  };

  return (
    <div 
      id="feedback"
      className="price-feedback-form"
      style={{
        marginTop: '30px',
        padding: '20px',
        background: theme.isDarkMode ? theme.colors.surface : '#f8f9fa',
        borderRadius: '12px',
        border: `1px solid ${theme.colors.border}`,
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box'
      }}
    >
      <h3 style={{ 
        fontSize: '18px',
        fontWeight: '600',
        marginBottom: '12px',
        color: theme.isDarkMode ? '#fff' : '#333'
      }}>Found an Issue or Have a Suggestion?</h3>
      
      {showForm ? (
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <textarea 
            placeholder="Spotted a price mismatch? Got an idea to make this better? Let us know!"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            style={{
              width: '100%',
              minHeight: '80px',
              padding: '10px',
              borderRadius: '8px',
              border: `1px solid ${theme.colors.border}`,
              marginBottom: '12px',
              fontSize: '14px',
              backgroundColor: theme.isDarkMode ? '#333' : '#fff',
              color: theme.isDarkMode ? '#fff' : '#333',
              boxSizing: 'border-box',
              resize: 'vertical'
            }}
          ></textarea>
          
          <button
            type="submit"
            style={{
              padding: '8px 16px',
              borderRadius: '6px',
              backgroundColor: theme.isDarkMode ? '#4a90e2' : '#2979ff',
              color: '#fff',
              border: 'none',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              width: '100%'
            }}
          >
            Submit Feedback
          </button>
        </form>
      ) : status && status.type === 'success' ? (
        <div 
          className="success-container"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px 0',
            animation: 'fadeIn 0.5s ease-in-out'
          }}
        >
          <div 
            className="checkmark"
            style={{
              fontSize: '32px',
              marginBottom: '12px',
              color: '#4caf50'
            }}
          >
            ✅
          </div>
          <p style={{
            textAlign: 'center',
            fontSize: '15px',
            lineHeight: '1.5',
            color: theme.isDarkMode ? '#e0e0e0' : '#444',
            margin: '0',
            maxWidth: '90%'
          }}>
            {status.message}
          </p>
        </div>
      ) : null}
      
      {status && status.type === 'error' && (
        <p style={{
          marginTop: '12px',
          padding: '10px',
          borderRadius: '6px',
          backgroundColor: '#f44336',
          color: '#fff',
          fontSize: '14px'
        }}>{status.message}</p>
      )}
      
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default PriceFeedbackForm; 